import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const options = [
  { title: "All", value: null },
  { title: "Featured", value: true },
  { title: "Not featured", value: false },
];

const SelectFeatured = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option.title}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Featured status"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectFeatured;
